import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '@tv3/shared/shared.module'
import { QRCodeModule } from 'angularx-qrcode'

import { AddUserDialogComponent } from '@tv3/containers/settings/user-settings/add/add-user-dialog.component'
import { UserOverlayComponent } from '@tv3/containers/settings/user-settings/overlays/user-overlay.component'
import { IsRestrictedPipe } from '@tv3/containers/settings/user-settings/overlays/is-restricted.pipe'
import { IsAllRestrictedPipe } from '@tv3/containers/settings/user-settings/overlays/is-all-restricted.pipe'
import { OwnerRentalsComponent } from '@tv3/containers/settings/owner-rentals/owner-rentals.component'
import { UsersLibModule } from '@tokeet-frontend/users'
import { UserMfaDialogComponent } from './user-settings/user-mfa-dialog/user-mfa-dialog.component'

const pipes = [IsRestrictedPipe, IsAllRestrictedPipe]

const components = [OwnerRentalsComponent]

const dialogs = [AddUserDialogComponent, UserOverlayComponent, UserMfaDialogComponent]

const services = []

@NgModule({
  imports: [SharedModule, CommonModule, UsersLibModule, QRCodeModule],
  declarations: [...components, ...dialogs, ...pipes],
  exports: [...components, ...dialogs, ...pipes],
  entryComponents: [...dialogs],
  providers: [...services],
})
export class SettingsSharedModule {}
